const QueryKeys = {

  /**
   * fetch clients data
   */
  CLIENTS: ['clients'],

  RECRUITERS: ['recruiters'],

  JOB_TITLES: ['job-titles'],

  JOB_TYPES: ['job-types'],

  LOCATIONS: ['locaitons'],

  SKILLS: ['skills'],

  JOBS: ['jobs'],

  CONSULTANCIES: ['consultancies'],

  INTERVIEWPOSITIONS: ['interview-positions'],

  STATUSES: ['statuses'],

  MAIL_TEMPLATES: ['mail-templates'],

  SOURCES: ['sources'],

  VENDORS: ['vendors'],
};

export default QueryKeys;
